export default __webpack_public_path__ + "static/AQP_Brochure_for_Children-10144713e963108fce42201240674528.pdf";